export default {
    listagem_etiquetas: 'Listado de Etiquetas',
    etiqueta_nao_encontrada: 'No se Encontraron Etiquetas',
    etiqueta: 'Etiqueta',
    status: {
        disponivel: 'Disponible',
        cancelada: 'Cancelado',
        pendente: 'Pendiente',
        usada: 'Usado'
    }
}